import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "../../components/ui/database-column-header";
import { useNavigate } from "react-router-dom";
import { HiTrash } from "react-icons/hi2";
import { Switch } from "@/components/ui/switch";
import { useRemoveContractLeads } from "./useRemoveContractLeads";
import { useSetReminder } from "./useSetReminder";
import { useGetLeads } from "./useGetLeads";
import { useState, useEffect } from "react";
import {formatDate2,  toPascalCase } from "../../utils/helpers";

function ReminderAction({ contract }) {
  const { data: leads, isLoading } = useGetLeads();
  const { mutate: setReminder } = useSetReminder();
  const proposalId = contract.NoticeId;

  const lead = leads?.find((lead) => lead.NoticeId === proposalId);
  const [reminderEnabled, setReminderEnabled] = useState(
    lead?.reminder || false
  );

  useEffect(() => {
    if (leads) {
      const currentLead = leads.find((lead) => lead.NoticeId === proposalId);
      setReminderEnabled(currentLead?.reminder || false);
    }
  }, [leads, proposalId]);

  const handleToggleReminder = (enabled) => {
    setReminderEnabled(enabled);
    setReminder({ proposalId, reminderEnabled: enabled });
  };

  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={reminderEnabled}
        onCheckedChange={handleToggleReminder}
        disabled={isLoading}
      />
    </div>
  );
}

function DeleteAction({ contract }) {
  const { mutate: removeLead } = useRemoveContractLeads();
  const proposalId = contract.NoticeId;
  const searchType = contract.searchType;

  return (
    <Button
      variant="ghost"
      className="h-8 w-8 p-0"
      onClick={() => removeLead({ proposalId, searchType })}
    >
      <HiTrash className="text-gray-600" />
      <span className="sr-only">Delete</span>
    </Button>
  );
}

function RowComponent({ row, children }) {
  const navigate = useNavigate();
  const contract = row.original;

  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate(`/contract/federal/${contract.NoticeId}`)}
    >
      {children}
    </div>
  );
}

export const fedColumns = [
  {
    accessorKey: "Title",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title="Title"
        className="w-[400px]"
      />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div className="font-medium">{toPascalCase(row.getValue("Title"))}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "ResponseDeadLine",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Deadline" />
    ),
    cell: ({ row }) => {
      return (
        <RowComponent row={row}>
          {formatDate2(row.getValue("ResponseDeadLine"))}
        </RowComponent>
      );
    },
  },
  {
    accessorKey: "Sub_Tier",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Dept. Sub-Tier" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{toPascalCase(row.getValue("Sub_Tier"))}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "Type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Type" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{row.getValue("Type")}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "SetASide",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Set-Aside" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        {row.getValue("SetASide") === "nan" ? null : (
          <div>{row.getValue("SetASide")}</div>
        )}
      </RowComponent>
    ),
  },
  {
    id: "remindMe",
    header: "Set Reminder",
    cell: ({ row }) => <ReminderAction contract={row.original} />,
    className: "sticky-col w-[600px]",
  },
  {
    id: "delete",
    header: "Delete",
    cell: ({ row }) => <DeleteAction contract={row.original} />,
    className: "sticky-col w-[100px]",
  },
];
